import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useState } from 'react';
import Router from 'next/router';
import _ from 'lodash';
import gql from 'graphql-tag';
import { ApolloConsumer } from 'react-apollo';
import EventTrackingHelper from "../../utils/trackingUtilities";
import { Icon, ClickedOutside } from "../_global";
import SearchResults from "./SearchResults";
import { SearchContainer, SearchBox, SearchBoxWrapper, SearchResultsContainer, Loading, LoadingWrapper, MessageWrapper, CancelButton, IconWrapper, ClearSearch } from "./style";
var searchQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query searchQuery($query: String!) {\n    bonusCampaignItems(first: 1) {\n      bonusRibbons {\n        color\n        backgroundColor\n        title\n        name\n      }\n    }\n    search(query: $query) {\n      merchantId\n      merchantName\n      calloutLabel\n      merchantLogoSquare\n      score\n    }\n  }\n"])));
var Search = function Search(_ref) {
  var isMobile = _ref.isMobile,
    onClearResults = _ref.onClearResults;
  var _useState = useState(false),
    searchActive = _useState[0],
    setSearchActive = _useState[1];
  var _useState2 = useState(''),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState(null),
    data = _useState4[0],
    setData = _useState4[1];
  var onSearchFocus = function onSearchFocus() {
    EventTrackingHelper.trackGenericAction('search');
  };
  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 13) {
      if (data && data.search && data.search.length === 1) {
        var _data$search$ = data.search[0],
          merchantId = _data$search$.merchantId,
          merchantName = _data$search$.merchantName;
        clearResults();
        EventTrackingHelper.trackGenericAction("search|".concat(merchantName));
        Router.push("/merchant?slug=".concat(merchantId.replace(/\+/g, '%2B')), "/".concat(merchantId)).then(function () {
          return window.scrollTo(0, 0);
        });
      }
    }
  };
  var handleChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, client) {
      var searchIt, searchText, _data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              searchIt = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
                  var _yield$client$query, data1;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return client.query({
                            query: searchQuery,
                            variables: {
                              query: t
                            }
                          });
                        case 2:
                          _yield$client$query = _context.sent;
                          data1 = _yield$client$query.data;
                          if (!(data1.search.length === 0 && t.indexOf('.') < 0)) {
                            _context.next = 6;
                            break;
                          }
                          return _context.abrupt("return", searchIt(t.split('').join('.')));
                        case 6:
                          return _context.abrupt("return", data1);
                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return function searchIt(_x3) {
                  return _ref3.apply(this, arguments);
                };
              }();
              searchText = e.target.value;
              setSearchText(searchText);
              if (searchText && searchText.length > 1) {
                openResults();
              } else {
                closeResults();
              }
              if (!(searchText && searchText.length > 1)) {
                _context2.next = 20;
                break;
              }
              setLoading(true);
              setData(null);
              // TODO: https://jira.qantas.com.au/browse/RETB-2763 requires rewards to be returned
              // despite not matching, find a better way to achieve once search refactored.
              if (searchText.toLowerCase().startsWith('woo')) {
                searchText = 'woolworth rewards';
              }
              _context2.prev = 8;
              _context2.next = 11;
              return searchIt(searchText);
            case 11:
              _data = _context2.sent;
              setLoading(false);
              setData(_data);
              _context2.next = 20;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](8);
              setLoading(false);
              setData(null);
            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 16]]);
    }));
    return function handleChange(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var openResults = function openResults() {
    setSearchActive(true);
  };
  var closeResults = function closeResults() {
    setSearchActive(false);
  };
  var clearResults = function clearResults() {
    setSearchActive(false);
    setSearchText('');
    if (searchActive) {
      onClearResults && onClearResults();
    }
  };
  var bonusRibbons = _.get(data, ['bonusCampaignItems', '0', 'bonusRibbons'], []);
  return __jsx(ApolloConsumer, null, function (client) {
    return __jsx(SearchContainer, {
      active: searchActive
    }, __jsx(SearchBoxWrapper, {
      className: "ignore-react-onclickoutside"
    }, __jsx(SearchBox, {
      type: "text",
      placeholder: 'Search for brands',
      onChange: function onChange(e) {
        return handleChange(e, client);
      },
      onKeyDown: onKeyDown,
      value: searchText,
      "aria-label": "Search for brands",
      onFocus: function onFocus() {
        return onSearchFocus();
      }
    }), isMobile && __jsx(ClearSearch, {
      onClick: clearResults,
      role: "none"
    }, "Clear"), !isMobile && __jsx(Icon, {
      iconType: "search",
      size: "sm"
    })), __jsx(ClickedOutside, {
      handleClickOutside: clearResults
    }, __jsx(SearchResultsContainer, null, loading && __jsx(LoadingWrapper, null, __jsx(Loading, null), __jsx("p", null, "Loading")), data && data.search && data.search.length < 1 && __jsx(MessageWrapper, null, __jsx(IconWrapper, null, __jsx(Icon, {
      iconType: "search",
      size: "xxxl"
    })), __jsx("p", null, "No results found. Please try again.")), data && data.search && data.search.length >= 1 && __jsx(SearchResults, {
      results: data.search,
      bonusRibbons: bonusRibbons,
      onResultClick: clearResults,
      term: searchText
    }))), __jsx(CancelButton, {
      onPress: clearResults
    }, "Cancel"));
  });
};
export default Search;